import { gql } from "@apollo/client";

export const getAllSitesForCustomerQuery = gql`
query($customerId: String!){
  getAllSiteForCustomer(customerId: $customerId) {
    message
    response
  }
}
`;


export const getSiteReportsScheduleQuery = gql `
query($siteId: String!){
  getAllScheduleForCustomerPortal(siteId: $siteId) {
    message
    response
  }
}
`;

// "Schedules" tab - guarding + mobile service duties for a site+date range,
// plus the Contracted/Scheduled/Diff hours header stat. Server-paginated
// (default pageSize 20, max 100 - clamped server-side).
export const getCustomerPortalScheduleGridQuery = gql`
query($siteId: String!, $customerId: String!, $startDate: String!, $endDate: String!, $search: String, $dutyTypeId: String, $status: String, $page: Float, $pageSize: Float, $sortOrder: String){
  getCustomerPortalScheduleGrid(siteId: $siteId, customerId: $customerId, startDate: $startDate, endDate: $endDate, search: $search, dutyTypeId: $dutyTypeId, status: $status, page: $page, pageSize: $pageSize, sortOrder: $sortOrder) {
    message
    response
  }
}
`;

// "Activity Logs" tab - clock in/out, check calls, tasks and checkpoint scans for a
// site+date range. Server-paginated (default pageSize 20, max 100).
export const getCustomerPortalActivityLogQuery = gql`
query($siteId: String!, $customerId: String!, $startDate: String!, $endDate: String!, $search: String, $status: String, $callType: String, $page: Float, $pageSize: Float, $sortOrder: String){
  getCustomerPortalActivityLog(siteId: $siteId, customerId: $customerId, startDate: $startDate, endDate: $endDate, search: $search, status: $status, callType: $callType, page: $page, pageSize: $pageSize, sortOrder: $sortOrder) {
    message
    response
  }
}
`;

// full checkcall log (clock in/out, check calls, tasks, checkpoints - expected vs
// actual time + location for each) for a single guarding duty, used to build the
// "Download Detail Duty Report" export behind the Schedules tab's row menu
export const getScheduleCheckCallsQuery = gql`
query($siteId: String!, $scheduleId: String!){
  getScheduleCheckCalls(siteId: $siteId, scheduleId: $scheduleId) {
    message
    response
  }
}
`;